export default "__VITE_ASSET__1886abe1__"